<nz-spin [nzSpinning]="loading">
  <div class="">
    <!-- <div>
      <span class="relative" (click)="Condition()">
        <span class="to-top"></span>
      </span>
      <strong class="black-title" style="margin-left: 18px">{{ "Condition" | translate }}</strong>
    </div> -->
    <nz-card style="margin-bottom: 10px;">
    <div class="查询条件" >
      <form nz-form [formGroup]="validateForm">
        <!-- 第一行 -->
        <div nz-row>
          <div nz-col nzSpan="2">
            <nz-form-label>
              <div class="width-100-percent label-font">
                {{ "Site" | translate }}
              </div>
            </nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-select formControlName="Site" style="width: 100px;">
                  <nz-option *ngFor="let option of SiteList" [nzLabel]="option" [nzValue]="option">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col nzSpan="4">
            <nz-form-label>
              <div class="width-100-percent label-font">
                {{ "AccountStatus" | translate }}
              </div>
            </nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-select formControlName="AccountStatus" nzShowSearch nzAllowClear >
                  <nz-option nzLabel='{{"All"|translate}}' nzValue="All"></nz-option>
                  <nz-option nzLabel='{{"effective"|translate}}' nzValue="Y"></nz-option>
                  <nz-option nzLabel='{{"noneffective"|translate}}' nzValue="D"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col nzSpan="8" nzPush="1" class="row-with-spacing-button">
            <button nz-button class="default-button" nzType="primary"
            (click)="onSearch()">
            <span nz-icon nzType="search"></span>
            {{"Query"|translate}}</button>
          </div>
        </div>
        <!-- 第二行 -->
        <!-- <div nz-row>

              <nz-form-label>{{"AccountStatus"|translate}}</nz-form-label>

              <nz-form-control>
                <nz-radio-group formControlName="AccountStatus" nzName="radiogroup">
                  <label nz-radio nzValue="D">{{"noneffective"|translate}}</label>
                  <label nz-radio nzValue="Y">{{"effective"|translate}}</label>
                  <label nz-radio nzValue="All">{{"All"|translate}}</label>
                </nz-radio-group>
              </nz-form-control>

            <td nz-col class="width-100-percent">
              <button nz-button class="default-button" nzType="primary"
                (click)="onSearch()">{{"Query"|translate}}</button>


        </div> -->
      </form>
    </div>
  </nz-card>
  <nz-card >
    <div class="表格" style="margin-top: 10px;">
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
      <nz-table #colSpanTable [nzData]="listOfData" nzSize="middle" nzShowSizeChanger [nzFrontPagination]="false"
        [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
        [nzScroll]="{ y: '400px',x:'1000px' }">
        <thead>
          <tr>
            <th scope="col">{{ "Site" | translate}}</th>
            <th scope="col">{{ "table.Company" | translate}}</th>
            <th scope="col">{{ "VendorMail" | translate}}</th>
            <th scope="col">{{ "VendorContact" | translate}}</th>
            <th scope="col">{{ "AccountValidDate" | translate}}</th>
            <th scope="col">{{ "LastLogInDate" | translate}}</th>
            <th scope="col">{{ "AccountExpirationReason" | translate}}</th>
            <th scope="col">{{ "AccountExpirationDate" | translate}}</th>
            <th scope="col">{{ "ModifyOperation" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data;let i=index">
            <ng-container *ngIf="!editCache[data.sid].edit; else editTemplate">
              <td>{{data.site}}</td>
              <td>{{data.companyCode}}</td>
              <td>{{data.vendorMail}}</td>
              <td>{{data.vendorContact}}</td>
              <td>{{data.bindTime}}</td>
              <td>{{data.lastLogin}}</td>
              <td>{{data.expiredReason}}</td>
              <td>{{data.expiredDate}}</td>
              <td><button nz-button nzType="primary" nz-popconfirm ngDefaultControl nzPopconfirmPlacement="topLeft"
                  (click)="startEdit(data.sid)">{{"Edit" | translate}}</button>
              </td>
            </ng-container>
            <ng-template #editTemplate>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.site" [disabled]="true" /></td>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.companyCode" [disabled]="true" />
              </td>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.vendorMail" [disabled]="false" />
              </td>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.vendorContact" [disabled]="false" />
              </td>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.bindTime" [disabled]="true" /></td>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.lastLogin" [disabled]="true" /></td>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.expiredReason" [disabled]="true" />
              </td>
              <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.expiredDate" [disabled]="true" />
              </td>
              <td>
                <a (click)="saveEdit(data.sid)" class="save">{{"Save" | translate}}</a>
                <a nz-popconfirm nzPopconfirmTitle="{{'UneditOrNot'|translate}}" (nzOnConfirm)="cancelEdit(data.sid)"
                  style="margin-left:20px;">{{"Cancel" | translate}}</a>
              </td>
            </ng-template>
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger  [nzPageSize]='pageSize' [nzPageSizeOptions]="[10, 20, 50,100]"
        (nzPageSizeChange)="nzPageSizeChange($event)"  (nzPageIndexChange)="nzPageIndexChange($event)">
      </nz-pagination>
      <ng-template #renderItemTemplate let-type let-page="page">
         
        <a *ngIf="type === 'page'">{{ page }}</a>
        <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
        <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
      </ng-template>
    </div>
  </nz-card>
  </div>

</nz-spin>